import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { MenuIdService } from './core/services/menu-id.service';
import { RestService } from './core/services/rest.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'KenIndia-Web';
  defaultLanguage: string = 'en'; // Default language variable
  timeInterval: any;
  isLogin: boolean = true;
  receivedData: any;
  isModules = false;
  screenConfigId: any;
  url: any;
  orgAppScreens: any;
  showHelpIcon: boolean = false;
  orgHelpScreenData: string = '';
  private breadcrumbHistory: any[] = [];
  lastBreadcrumbIndex: number | null = null;
  isScrnConfig = false;
  menuID!: number;
  img!: string;
  constructor(
    private titleService: Title,
    public Translate: TranslateService,
    public menuIdService: MenuIdService,
    private restService: RestService,
    private router: Router
  ) {
    this.setLanguage(this.defaultLanguage); // Set the default language
    // this.loadAdditionalTranslations(this.defaultLanguage);
    window.addEventListener('popstate', () => this.handlePopState());
    this.dynamicUIOnChange();
  }
  

  ngOnInit(): void {
    this.timeInterval = setInterval(() => {
      if (sessionStorage.getItem('breadCrumbs')) {
        this.receivedData = sessionStorage.getItem('breadCrumbs');
      }
      this.isScrnConfig =
        window.location.pathname.includes('screen-configurer') ||
        window.location.pathname.includes('screen-stepper-config')
          ? true
          : false;
      this.isModules =
        window.location.pathname.includes('forms') ||
        window.location.pathname.includes('product-config') ||
        window.location.pathname.includes('auth') ||
        window.location.pathname.includes('home') ||
        window.location.pathname.includes('error') ||
        window.location.pathname.includes('create-module-config') ||
        window.location.pathname.includes('screen-config') ||
        window.location.pathname.includes('widgets') ||
        window.location.pathname.includes('help-document') ||
        window.location.pathname.includes('org-structure') ||
        window.location.pathname.includes('/view/policy_underwriting/') ||
        window.location.pathname.includes('/view/group_policy_underwriting/')
          ? true
          : false;
      this.isLogin = window.location.pathname.includes('login') ? true : false;
    }, 500 * 1);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // The URL has changed
        window.scroll(0, 0);
        // You can perform actions or call functions here
        this.url = event.url;
        const urlSegments = event.url.split('/');
        const idPattern =
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
        const screenConfigId = urlSegments.find((segment) =>
          idPattern.test(segment)
        );

        if (screenConfigId) {
          let url_parts = this.url?.split('/');
          this.screenConfigId = url_parts[url_parts.length - 1];
          // if (!this.isModules && !this.shouldHideBreadCrumbs() && !window.location.pathname.includes('forms'))
          //   this.fetchHelpScreen();
        }
      }
    });
  }

  dynamicUIOnChange() {
    const currentUrl = window.location.hostname;
    switch (true) {
      // case currentUrl.includes('uat-core-primez.insure.digital.com'):
      // case currentUrl.includes('uat-core'):
      // case currentUrl.includes('.insure.digital'):
      //   this.menuIdService.getImagePath(6130,'uat-core-primez.insure.digital.com');
      //   this.menuID = 6130;
      //   document.body.classList.add('afrisure');
      //   this.changeBrowserTitle('KenIndia');
      //   this.changeFavicon('assets/images/faviconLogo/afrisurefaviconlogo.png');
      //   break;
      case currentUrl.includes('malawi.com'):
      case currentUrl.includes('malawi'):
        this.menuIdService.getImagePath(6050,'malawi.com'); // malawi
        this.menuID = 6050;
        document.body.classList.add('malawi');
        this.changeBrowserTitle('DMVIC-IAM-MOTOR');
        this.changeFavicon('assets/images/faviconLogo/IAM2_favicon.png');

        break;
      case currentUrl.includes('uaedemo-primez.insure.digital'):
        this.menuIdService.getImagePath(6130,'uaedemo-primez.insure.digital');
        this.menuID = 6130;
        document.body.classList.add('primeZ');
        this.changeBrowserTitle('KenIndia');
        this.changeFavicon('assets/images/faviconLogo/afrisurefaviconlogo.png');
        this.menuIdService.getFooterContent('uaedemo-primez.insure.digital');
        // this.menuID = 6050;
        // document.body.classList.add('malawi');
        // this.changeBrowserTitle('DMVIC-IAM-MOTOR');
        // this.changeFavicon('assets/images/faviconLogo/IAM2_favicon.png');
        break;
        case currentUrl.includes('sudlife-primez.insure.digital'):
          this.menuIdService.getImagePath(6130,'sudlife-primez.insure.digital');
          this.menuID = 6130;
          document.body.classList.add('primeZ');
          this.changeBrowserTitle('KenIndia');
          this.changeFavicon('assets/images/faviconLogo/afrisurefaviconlogo.png');
          this.menuIdService.getFooterContent('sudlife-primez.insure.digital');
          break;
          case currentUrl.includes('cholams-primez.insure.digital'):
            this.menuIdService.getImagePath(6130,'cholams-primez.insure.digital');
            this.menuID = 6130;
            document.body.classList.add('primeZ');
            this.changeBrowserTitle('KenIndia');
            this.changeFavicon('assets/images/faviconLogo/afrisurefaviconlogo.png');
            this.menuIdService.getFooterContent('cholams-primez.insure.digital');
            break;
            case currentUrl.includes('zuno-primez.insure.digital'):
              this.menuIdService.getImagePath(6130,'zuno-primez.insure.digital');
              this.menuID = 6130;
              document.body.classList.add('primeZ');
              this.changeBrowserTitle('KenIndia');
              this.changeFavicon('assets/images/faviconLogo/afrisurefaviconlogo.png');
              this.menuIdService.getFooterContent('zuno-primez.insure.digital');
              break;
              case currentUrl.includes('starhealth-primez.insure.digital'):
                this.menuIdService.getImagePath(6130,'starhealth-primez.insure.digital');
                this.menuID = 6130;
                document.body.classList.add('primeZ');
                this.changeBrowserTitle('KenIndia');
                this.changeFavicon('assets/images/faviconLogo/afrisurefaviconlogo.png');
                this.menuIdService.getFooterContent('starhealth-primez.insure.digital');
                break;
        case currentUrl.includes('localhost'):
          this.menuIdService.getImagePath(6130,'localhost');
          this.menuIdService.getFooterContent('localhost');
          this.menuID = 6130;
          document.body.classList.add('afrisure');
          this.changeBrowserTitle('KenIndia');
          this.changeFavicon('assets/images/faviconLogo/afrisurefaviconlogo.png');
          // this.menuID = 6050;
          // document.body.classList.add('malawi');
          // this.changeBrowserTitle('DMVIC-IAM-MOTOR');
          // this.changeFavicon('assets/images/faviconLogo/IAM2_favicon.png');
          break;
          default:
             this.menuIdService.getImagePath(6130,'uat-core-primez.insure.digital.com');
        this.menuID = 6130;
        document.body.classList.add('afrisure');
        this.changeBrowserTitle('KenIndia');
        this.changeFavicon('assets/images/faviconLogo/afrisurefaviconlogo.png');
        break;
    }
  }

  changeBrowserTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  changeFavicon(newFaviconPath: string) {
    const favicon = document.getElementById(
      'dynamic-favicon'
    ) as HTMLLinkElement;
    if (favicon) {
      favicon.href = newFaviconPath;
    }
  }

  shoulHideMenu() {
    return (
      this.router.url.includes('help-document-new') ||
      this.router.url.includes('auth/forgot_password') ||
      this.router.url.includes('error/error-status') ||
      this.router.url.includes('error/internal-error') ||
      this.router.url.includes('quotation/compare-product-whatsapp') 
    );
  }
  handlePopState() {
    this.breadcrumbHistory = JSON.parse(
      sessionStorage.getItem('BCArray') || ''
    );
    const lastBreadcrumbIndex = this.breadcrumbHistory.findIndex((bc: any) =>
      window.location.pathname.includes(bc.url)
    );
    this.receivedData =
      this.breadcrumbHistory[lastBreadcrumbIndex]?.breadCrumb || '';
    sessionStorage.setItem('breadCrumbs', this.receivedData);
  }

  proposalLoginMenu():boolean{
    return( this.router.url.includes('/auth/proposal-form-login')||
    this.router.url.includes('/auth/proposal-form-getAll')
    )
 
    }

    openHelpDocument() {
      const windowFeatures = 'height=600,width=1100,scrollbars=yes,resizable=yes';
  
      window.open(
        `/create/help-document-new/${this.screenConfigId}`,
        '_blank',
        windowFeatures
      );
    }

    shouldHideBreadCrumbs(): boolean {
      return (
        this.router.url.includes('help-document-new') ||
        this.router.url.includes('view/my-profile') ||
        this.router.url.includes('view/view-profile')||
        this.router.url.includes('routing-module/')||
        this.router.url.includes('routing-sub-module/')
      );
    }

    loadAdditionalTranslations(language: string) {
      this.restService
        .getData<any>('assets/apitest.json', true)
        .subscribe((data) => {
          this.Translate.setTranslation(language, {
            ...this.Translate.translations[language],
            ...data,
          });
   
          this.setLanguage(this.defaultLanguage);
        });
    }
   
    setLanguage(language: string) {
      this.Translate.setDefaultLang(language); // Set default language
      this.Translate.use(language); // Use the specified language
    }

    hideMenuInPaymentScreen() {
      // Define the patterns for the specific URLs
      const patterns = [
          /\/policy\/payment-external-info\//,
          /\/policy\/payment-external\//
      ];
  
      // Check if the current URL matches any of the patterns
      for (let pattern of patterns) {
          if (pattern.test(this.router.url)) {
              return true; // Hide the menu
          }
      }
  
      return false; // Do not hide the menu
  }
  
  
  

}
